<!--
 * @Author: zouyuping
 * @version: 
 * @Date: 2022-04-18 15:48:13
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-08 11:16:35
 * @FilePath: 
 * @Description: 技师做钟房间列表
-->
<template>
  <div class="group_page_container">
    <div class="content_view">
      <ul class="jishi_grid_list">
        <li v-for="(item, index) in jishiClockList" :key="index" class="jishi_card">
          <div class="card_header">
            <span class="jishi_id">技师号：{{ item.JishiId }}</span>
            <span :class="['clock_type', getClockTypeClass(item.ClockType)]">{{ item.ClockType }}</span>
          </div>
          <div class="card_body">
            <div class="info_row">
              <span class="label">做钟项目：</span>
              <span class="value">{{ item.ProjectName }}</span>
            </div>
            <div class="info_row">
              <span class="label">手牌号：</span>
              <span class="value">{{ item.HandCode }}</span>
            </div>
            <div class="info_row">
              <span class="label">房间号：</span>
              <span class="value">{{ item.RoomNo }}</span>
            </div>
          </div>
        </li>
      </ul>
      
      <div v-if="jishiClockList.length === 0" class="empty_state">
        <p>暂无技师做钟信息</p>
      </div>
    </div>
    <myFooter></myFooter>
  </div>
</template>

<script>
import myFooter from "@/components/myFooter";
import { mapState } from "vuex";
export default {
  name: "JiShiClockRoom",
  components: {
    myFooter,
  },
  data() {
    return {
      jishiClockList: [
        { JishiId: "001", ClockType: "点钟", ProjectName: "足疗按摩", HandCode: "A001", RoomNo: "101" },
        { JishiId: "002", ClockType: "加钟", ProjectName: "全身推拿", HandCode: "B002", RoomNo: "102" },
        { JishiId: "003", ClockType: "排钟", ProjectName: "精油SPA", HandCode: "C003", RoomNo: "103" },
        { JishiId: "004", ClockType: "Call钟", ProjectName: "足底拔罐", HandCode: "D004", RoomNo: "104" },
        { JishiId: "005", ClockType: "跳钟", ProjectName: "刮痧理疗", HandCode: "E005", RoomNo: "105" },
        { JishiId: "006", ClockType: "点钟", ProjectName: "艾灸养生", HandCode: "F006", RoomNo: "106" },
        { JishiId: "007", ClockType: "加钟", ProjectName: "泰式按摩", HandCode: "G007", RoomNo: "107" },
        { JishiId: "008", ClockType: "排钟", ProjectName: "头部按摩", HandCode: "H008", RoomNo: "108" },
        { JishiId: "009", ClockType: "Call钟", ProjectName: "肩部放松", HandCode: "I009", RoomNo: "109" },
      ],
    };
  },
  computed: {
    ...mapState({
      vpnId: (rootState) => rootState.vpnId,
    }),
  },
  created() {},
  mounted() {},
  methods: {
    getClockTypeClass(type) {
      const typeMap = {
        "点钟": "type-dian",
        "加钟": "type-jia",
        "排钟": "type-pai",
        "Call钟": "type-call",
        "跳钟": "type-tiao",
      };
      return typeMap[type] || "";
    },
  },
};
</script>
<style scoped lang="scss">
.group_page_container {
  padding-bottom: calc(100px + env(safe-area-inset-bottom));
  min-height: calc(100vh - 100px - env(safe-area-inset-bottom));
  display: flex;
  flex-direction: column;
  background-color: #f4f6f8;
}

.content_view {
  flex: 1;
  padding: 32rpx;
  box-sizing: border-box;
}

.jishi_grid_list {
  display: flex;
  flex-wrap: wrap;
  margin: -12rpx;
  padding: 0;
  list-style: none;
}

.jishi_card {
  width: calc(50% - 24rpx);
  min-width: 0;
  margin: 12rpx;
  background-color: #fff;
  border: 1rpx solid #e8ebef;
  border-radius: 12rpx;
  padding: 24rpx;
  box-shadow: 0 4rpx 12rpx rgba(31, 45, 61, 0.04);
  box-sizing: border-box;
  
  .card_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12rpx;
    padding-bottom: 18rpx;
    border-bottom: 1rpx solid #edf0f3;
    
    .jishi_id {
      min-width: 0;
      font-size: 28rpx;
      font-weight: 600;
      color: #202832;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    
    .clock_type {
      flex-shrink: 0;
      font-size: 22rpx;
      line-height: 1;
      padding: 8rpx 12rpx;
      border-radius: 6rpx;
      
      &.type-dian {
        background-color: #ffeef0;
        color: #ee0a24;
      }
      
      &.type-jia {
        background-color: #fff7e6;
        color: #d46b08;
      }
      
      &.type-pai {
        background-color: #f6ffed;
        color: #52c41a;
      }
      
      &.type-call {
        background-color: #e6f7ff;
        color: #1890ff;
      }
      
      &.type-tiao {
        background-color: #f9f0ff;
        color: #722ed1;
      }
    }
  }
  
  .card_body {
    .info_row {
      display: flex;
      align-items: center;
      min-height: 46rpx;
      
      .label {
        font-size: 24rpx;
        color: #8b95a1;
        flex-shrink: 0;
      }
      
      .value {
        font-size: 24rpx;
        color: #303944;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}

.empty_state {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100rpx 0;
  
  p {
    font-size: 28rpx;
    color: #999;
  }
}

@media screen and (max-width: 375px) {
  .jishi_card {
    padding: 20rpx;
    
    .card_header {
      .jishi_id {
        font-size: 26rpx;
      }
      
      .clock_type {
        font-size: 20rpx;
        padding: 4rpx 12rpx;
      }
    }
    
    .card_body {
      .info_row {
        padding: 10rpx 0;
        
        .label, .value {
          font-size: 22rpx;
        }
      }
    }
  }
}

@media screen and (min-width: 414px) {
  .jishi_card {
    padding: 28rpx;
    
    .card_header {
      .jishi_id {
        font-size: 30rpx;
      }
      
      .clock_type {
        font-size: 24rpx;
        padding: 8rpx 20rpx;
      }
    }
    
    .card_body {
      .info_row {
        padding: 14rpx 0;
        
        .label, .value {
          font-size: 26rpx;
        }
      }
    }
  }
}
</style>
